import React, { useState } from 'react';
import { Button, Card, Space, Typography, message as antMessage } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import assistant from '../../services/assistant';

const { Text, Paragraph } = Typography;

const TeamAssistantCatalogActionCard = ({ action, onDismiss, onConfirmed }) => {
  const [loading, setLoading] = useState(false);

  if (!action || action.type !== 'create_company') {
    return null;
  }

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const res = await assistant.confirmCatalogAction(action.action_id);
      const company = res.data?.data?.company ?? res.data?.company;
      const name = company?.name;
      if (company?.edit_url) {
        antMessage.success(
          <span>
            {name ? `Created ${name}. ` : 'Company created. '}
            <a href={company.edit_url} target="_blank" rel="noreferrer">Edit company</a>
          </span>
        );
      } else {
        antMessage.success(name ? `Created ${name}` : 'Company created');
      }
      onConfirmed?.(company);
      onDismiss?.(action.action_id);
    } catch (e) {
      antMessage.error(e?.response?.data?.message || e.message || 'Could not create company');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card size="small" className="team-assistant-catalog-action-card" title="Create company — confirm">
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Text strong>{action.name}</Text>
        <Text type="secondary">
          LOB: {(action.lines_of_business || []).join(', ') || '—'}
        </Text>
        <Text type="secondary">
          States: {(action.states || []).join(', ') || '—'}
        </Text>
        {action.general_info_preview && (
          <Paragraph type="secondary" className="team-assistant-catalog-action-preview">
            {action.general_info_preview}
          </Paragraph>
        )}
        <Space wrap>
          <Button
            type="primary"
            icon={<CheckOutlined />}
            loading={loading}
            onClick={handleConfirm}
          >
            Create company
          </Button>
          <Button icon={<CloseOutlined />} disabled={loading} onClick={() => onDismiss?.(action.action_id)}>
            Dismiss
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export default TeamAssistantCatalogActionCard;
